module.exports = __webpack_public_path__ + "img/sweep.f92d478f.svg";